import React from 'react';
import './CallerIdentification.css';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaTruck } from 'react-icons/fa';
import { FiUser } from 'react-icons/fi';

const CallerIdentification = () => {
  const caller = {
    name: 'Sarah Mitchell',
    title: 'Dispatcher, FastTrack Logistics Inc.',
    phone: '(555) 234-5678',
    email: 'sarah.mitchell@fasttrack.com',
    location: 'Chicago, IL',
    mcNumber: 'MC# 123456',
    stats: {
      totalLoads: 24,
      rating: 4.8,
      activeLoads: 3,
    },
  };

  return (
    <div className="caller-id-section">
      <h4>Here’s who’s calling</h4>
      <div className="caller-details">
        <div className="caller-info">
          <FiUser className="caller-icon" />
          <div className="caller-contact">
            <p className="caller-name">{caller.name}</p>
            <p className="caller-title">{caller.title}</p>
            <div className="contact-details">
              <p><FaPhone /> {caller.phone}</p>
              <p><FaEnvelope /> {caller.email}</p>
              <p><FaMapMarkerAlt /> {caller.location}</p>
              <p><FaTruck /> {caller.mcNumber}</p>
            </div>
          </div>
        </div>
        <div className="caller-stats">
          <div className="stat-box">
            <p className="stat-value">{caller.stats.totalLoads}</p>
            <p className="stat-label">Total Loads</p>
          </div>
          <div className="stat-box">
            <p className="stat-value">{caller.stats.rating}</p>
            <p className="stat-label">Rating</p>
          </div>
          <div className="stat-box">
            <p className="stat-value">{caller.stats.activeLoads}</p>
            <p className="stat-label">Active Loads</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CallerIdentification;